<template>
  <cumulus-edit-form
    ref="form"
    :icon="icon"
    :title="title"
    :new-item="false"
    :can-delete="false"
    @escape="escape"
    @save="save"
  >
    <template v-slot:editform>
      <edit-form
        :password="edited_item"
      />
    </template>
  </cumulus-edit-form>
</template>

<script>
  // Utilities
  import { call } from 'vuex-pathify'

  export default {
    name: 'ChangePassword',
    components: {
      EditForm: () => import('@/layouts/default/edit/UserPassword'),
    },
    data: function () {
      return {
        icon: '$fingerprint',
        title: 'change_password',
        edited_item: {},
        loading: false,
        prevRoute: '',
        saved: false,
      }
    },
    computed: {
    },
    mounted () {
    },
    methods: {
      setPassword: call('profile/updatePassword'),
      async save () {
        await this.setPassword(this.edited_item).then(response => {
          this.escape()
        }).catch(e => {
          this.$refs.form.setErrors(e)
        })
      },
      escape () {
        // this.getOrganizations()
        this.$router.push(this.prevRoute.path).catch(() => {})
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
  }
</script>
